import { translatedMessages } from './Traducciones_lang'

const translatedMessagesExport = translatedMessages

export default translatedMessagesExport
